import { useEffect } from 'react'

import { Box, Button, Stack, Text } from '@chakra-ui/react'
import {
  StaticScreen,
  StaticScreenContent,
  StaticScreenTitle,
} from 'src/components/StaticScreen/StaticScreen'
import { useVideoCallRoom } from 'src/features/videoCall/context/videoCallRoomContext'
import { useQuery } from 'src/hooks/use-query'

export const PatientFinishedScreen: React.FC = () => {
  const query = useQuery()
  const returnUrl = query.get('returnUrl')
  const { leave } = useVideoCallRoom()

  useEffect(() => {
    leave()
  }, [leave])

  return (
    <StaticScreen colorScheme="green">
      <StaticScreenTitle>説明ルームから退出しました。</StaticScreenTitle>
      <StaticScreenContent>
        <Stack spacing="14">
          <Text>ブラウザのタブを閉じてください。</Text>
          {!!returnUrl && (
            <Box>
              <Button
                w="200px"
                colorScheme="green"
                variant="outline"
                onClick={() => {
                  window.location.href = returnUrl
                }}
              >
                面談に戻る
              </Button>
            </Box>
          )}
        </Stack>
      </StaticScreenContent>
    </StaticScreen>
  )
}
